import validate from "/workd/WORKD/PROJECT_AIMI/aimi-barcode-n3/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/workd/WORKD/PROJECT_AIMI/aimi-barcode-n3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/workd/WORKD/PROJECT_AIMI/aimi-barcode-n3/dashboard/core/middleware/auth.ts")
}